import React from "react";
import CandidateEmail from "../CandidateEmail/CandidateEmail";
import { useState, useRef } from "react";
import history from "../../routes/history";
import {
  candidateDetailInit,
  candidateDetailSuccess,
} from "../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { candidateEmailExistApi } from "../../API/API";
import ProgressBar from "../ProgressBar/ProgressBar";

const AddCandidateEmail = ({ isCandidateRoute = false }) => {
  const [loading, setLoading] = useState(false);
  const [emailValidation, setEmailValidation] = useState("");
  const inputvalue = useRef(null);
  //   const getInputValues = JSON.parse(localStorage.getItem('CandidateObject')) || "";
  const [message, setMessage] = useState({});
  const getInputValues = useSelector(
    (state) => state.candidateReducer.candidateDetails
  );
  const dispatch = useDispatch();

  const clearValidation = (e) => {
    setEmailValidation("");
    const emailValue = e.target.value;
  };

  const isUserExist = async (email) => {
    try {
      const res = await candidateEmailExistApi(email);
      if (res.valid) return false;
      else return res.msg;
    } catch (error) {
      console.warn("error", error);
      if (typeof error == "string") return error || "Something went wrong";
      else return "Something went wrong";
    }
  };

  const nextHandler = async () => {
    try {
      setLoading(true);
      const emailValue = inputvalue.current.value.trim();
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailValue) {
        setEmailValidation("Your email is required");
        return;
      } else if (!emailPattern.test(emailValue)) {
        setEmailValidation("Please enter a valid email address.");
        return;
      }
      const error = await isUserExist(emailValue);
      if (error) {
        setEmailValidation(error);
        return;
      }
      dispatch(
        candidateDetailSuccess({ ...getInputValues, email: emailValue })
      );
      history.push("/add-candidate-name");
    } catch {
    } finally {
      setLoading(false);
    }
  };
  const backHandler = () => {
    dispatch(candidateDetailInit());
    if (isCandidateRoute) {
      history.push("/inviteTalents");
    } else {
      history.push("/employerdashboard");
    }
  };
  return (
    <CandidateEmail
      CandidateProgressBar={
        <ProgressBar percent={10} heading={"Create candidate’s profile"} />
      }
      CandidateText="Candidate’s email"
      placeholder="candidatename@domain.com"
      nextHandler={nextHandler}
      backHandler={backHandler}
      inputvalue={inputvalue}
      loading={loading}
      types="email"
      validation={emailValidation}
      clearValidation={clearValidation}
      getInputValues={getInputValues?.email}
    />
  );
};

export default AddCandidateEmail;
